import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { BaseService } from 'src/app/services/base.service';
import { LOCATION_STATE_TOKEN } from 'src/app/store/location/location.state';
import {
  PendingAssignment,
  PendingSeatAssignmentResponse
} from 'src/app/models';
import { map, Observable } from 'rxjs';
import { HostModeHelper } from 'src/app/helpers';
import { ErrorService } from 'src/app/services/error/error.service';
import { ApiType } from 'src/app/pos.config';

@Injectable({
  providedIn: 'root'
})
export class HostModeService extends BaseService {
  constructor(
    store: Store,
    private http: HttpClient,
    private readonly errorService: ErrorService
  ) {
    super(store);
  }

  /** Pending seat assign */
  getPendingAssignments(
    locationId = this.location.id
  ): Observable<PendingAssignment[]> {
    return this.http
      .get<{ pending_seat_assignments: PendingSeatAssignmentResponse[] }>(
        this.getLocationUrl('pending_seat_assignments', locationId)
      )
      .pipe(
        this.errorService.retryPipe(ApiType.Query),
        map((response) =>
          HostModeHelper.getAllPendingAssignments(
            response.pending_seat_assignments
          )
        )
      );
  }

  newSeatAssignment(
    params: { guest: boolean; table_id: number; diner_id?: number },
    locationId = this.location.id
  ) {
    return this.http
      .post<{ success: boolean; seat_assignment_id: number }>(
        this.getLocationUrl('pending_seat_assignments', locationId),
        params
      )
      .pipe(this.errorService.retryPipe(ApiType.Mutate));
  }

  closeAssignment(id: number, locationId = this.location.id) {
    return this.http
      .put<{ success: boolean; seat_assignment_id: number }>(
        this.getLocationUrl(`pending_seat_assignments/${id}`, locationId),
        undefined
      )
      .pipe(this.errorService.retryPipe(ApiType.Mutate));
  }

  deleteAssignment(id: number, locationId = this.location.id) {
    return this.http
      .delete(this.getLocationUrl(`pending_seat_assignments/${id}`, locationId))
      .pipe(this.errorService.retryPipe(ApiType.Mutate));
  }

  get location() {
    return this.store.selectSnapshot(LOCATION_STATE_TOKEN).location;
  }
}
